module.exports = __webpack_public_path__ + "static/media/dog.0225e787.glb";